export const storeConfig = {};
export const storeConfigWithoutPersist = {};
